// extracted by mini-css-extract-plugin
export default {"wrapper":"TableItem_wrapper__Yc9p-","title":"TableItem_title__yOON-","value":"TableItem_value__yM2Ol"};